import NoExistWorkspace from "@/app/common/pages/NoExistWorkspace.vue";
import LoginWithFacebook from "@/app/common/pages/LoginWithFacebook.vue";
import DeleteFacebookPage from "@/app/common/pages/DeleteFacebookPage.vue";
import LoginWithInstagram from "@/app/common/pages/LoginWithInstagram.vue";
import DeleteInstagramPage from "@/app/common/pages/DeleteInstagramPage.vue";
import SupportPage from "@/app/common/pages/SupportPage.vue";

export default [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/not-found-workspace",
    component: NoExistWorkspace,
    meta: {
      requiresAuth: false,
      layout: "footer",
    },
  },
  {
    path: "/loginFacebook",
    component: LoginWithFacebook,
    meta: {
      requiresAuth: false,
      layout: "empty",
    },
  },
  {
    path: "/deleteFacebookPage",
    component: DeleteFacebookPage,
    meta: {
      requiresAuth: false,
      layout: "empty",
    },
  },
  {
    path: "/loginInstagram",
    component: LoginWithInstagram,
    meta: {
      requiresAuth: false,
      layout: "empty",
    },
  },
  {
    path: "/deleteInstagramPage",
    component: DeleteInstagramPage,
    meta: {
      requiresAuth: false,
      layout: "empty",
    },
  },
  {
    path: "/support",
    component: SupportPage,
    meta: {
      requiresAuth: false,
      layout: "footer",
      hideClouds: true,
    },
  },
  {
    path: "/plan-config/upgrade-downgrade",
    component: () => import("@/app/common/pages/UpgradeDowngradePage.vue"),
    meta: {
      requiresAuth: false,
      layout: "empty",
      // layout: "footer",
      hideClouds: true,
    },
  },
  {
    path: "/plan-config/upgrade-downgrade/config",
    component: () => import("@/app/common/pages/UpgradeDowngradeConfigPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "empty",
      hideClouds: true,
    },
  },
  {
    path: "/restringed/temporal",
    component: () => import("@/app/common/pages/RestringedTemporal.vue"),
    meta: {
      requiresAuth: true,
      layout: "footer",
      // hideClouds: true,
    },
  },
  // {
  //   path: "/:catchAll(.*)",
  //   name: "NotFound",
  //   component: NotFoundPage,
  //   meta: {
  //     requiresAuth: false,
  //     layout: "footer",
  //   },
  // },
];
